// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--ZPeNb","comment_controls":"dece2e673c--comment_controls--E7wMm","comment_content":"dece2e673c--comment_content--XJRJY"};